module.exports = __webpack_public_path__ + "static/media/flria shot 02.32ec03ec.webp";